// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"e3Gms":[function(require,module,exports) {
/*----------------------------
Styles
----------------------------*/ // import "../../../styles/templates/customers/customers.scss";
// import "../../../styles/templates/customers/login.scss";
/*----------------------------
Scripts
----------------------------*/ // Components
var _sectionSwitcher = require("../../components/section-switcher");
document.addEventListener("DOMContentLoaded", (event)=>{
    /*----------------------------
  Show Reset Password Success Message
  ----------------------------*/ const formState = document.querySelector(".reset-password-success");
    const resetSuccessMessage = document.querySelector("#reset-success-message");
    // Check if our span element for successfully password reset exists on the page. If so then it was successfully submitted.
    // Show the success message that exists outside of the password reset form.
    if (formState) resetSuccessMessage.style.display = "block";
});

},{"../../components/section-switcher":"xl2J6"}],"xl2J6":[function(require,module,exports) {
/*----------------------------
Easily show/hide sections of a page by clicking links.
Specifically used on login and forgot password pages to dynamically show forms.
----------------------------*/ /*----------------------------
Section Switcher
----------------------------*/ function initSectionSwitcher() {
    /*--- Save the different section switcher links and switchable sections on the page ---*/ const sectionSwitchers = document.querySelectorAll(".section-switcher");
    const switchableSections = document.querySelectorAll(".switchable-section");
    /*--- Show Section ---*/ function showSection(sectionHash) {
        // Hide all switchable sections on the page
        Array.from(switchableSections).forEach((section)=>{
            section.style.display = "none";
        });
        // Show the new section
        const sectionToShow = document.querySelector(sectionHash);
        sectionToShow.style.display = "block";
    }
    /*--- Section link click events ---*/ Array.from(sectionSwitchers).forEach((sectionSwitcher)=>{
        // On click show the respective section.
        sectionSwitcher.addEventListener("click", (e)=>{
            // Prevent default
            e.preventDefault();
            // Show Section
            showSection(`#${sectionSwitcher.dataset.sectionToShow}`);
        });
    });
    /*--- Hash Section Changer ---*/ function checkHash() {
        const hash = window.location.hash;
        // If a hash exists in the url and there is a switchable section on the page with that hash then show that section.
        if (hash && document.querySelector(`${hash}.switchable-section`)) showSection(hash);
    }
    checkHash();
}
/*-------------------------------
Init
-------------------------------*/ document.addEventListener("DOMContentLoaded", (event)=>{
    initSectionSwitcher();
});

},{}]},["e3Gms"], "e3Gms", "parcelRequire83e8")

//# sourceMappingURL=template.login.js.map
